import React, { useEffect, useState } from 'react';
import { GroupedItems } from '../../../../../../../shared/lib/functional';
import { buildDateOption } from '../../../../../../../shared/lib/reserve';
import {
  createIsoDateList,
  isoToDateLocal,
  isoLocal,
  addDaysToDateLocal,
  dateToIsoLocal,
} from '../../../../../../../shared/lib/time';
import { DateOption } from '../../../../../../../shared/types/reserve';
import { ReserveCacheSlot } from '../../../../../../../shared/types/reserveCache';
import Button from './Button';

interface DatePickerProps {
  selectedDate?: DateOption;
  onSelectedDate: (date: DateOption) => void;
  timeslots?: GroupedItems<ReserveCacheSlot>;
}

export function DatePicker(props: DatePickerProps) {
  const { selectedDate, onSelectedDate, timeslots } = props;

  function resetAnchorDate() {
    return selectedDate ? isoToDateLocal(selectedDate.key) : new Date();
  }

  const [anchorDate, setAnchorDate] = useState<Date>(resetAnchorDate());

  const windowStart = addDaysToDateLocal(anchorDate, -2);
  const todayIso = isoLocal();
  const startIso = dateToIsoLocal(windowStart) < todayIso ? todayIso : dateToIsoLocal(windowStart);

  const dayViews: DateOption[] = createIsoDateList(startIso, 6).map(d =>
    buildDateOption(d, timeslots)
  );

  useEffect(() => {
    setAnchorDate(resetAnchorDate());
  }, [selectedDate?.key]);

  return (
    <div className="flex flex-wrap gap-4">
      {dayViews.map(day => {
        const isSelected = day.key === selectedDate?.key;

        return (
          <Button
            key={day.key}
            variant={isSelected ? 'accent' : 'borderlike'}
            aria-label={`Select ${day.weekday}, ${day.monthDay}`}
            onClick={() => {
              if (!isSelected) {
                onSelectedDate(day);
                setAnchorDate(day.date);
              }
            }}
            className={isSelected ? 'no-disabled' : ''}
          >
            <div className="grid grid-cols-1 gap-3 px-3 py-2">
              <div className="grid grid-cols-1 gap-1">
                <div className={`${isSelected ? 'text-white' : 'text-secondary'} text-sm`}>
                  {day.weekday}
                </div>
                <div className={`${isSelected ? 'text-white' : 'text-accent'} font-bold`}>
                  {day.monthDay}
                </div>
              </div>
              {timeslots && (
                <div className={`${isSelected ? 'text-white' : 'text-base'} text-sm`}>
                  {day.timesCount} times
                </div>
              )}
            </div>
          </Button>
        );
      })}
    </div>
  );
}
